(function () {
    "use strict";

    window.app.filter("data", function () {
        return function (gigabytes) {
            var formatted = "";

            if (gigabytes === -1) {
                formatted = "Unlimited";
            }
            else if (gigabytes) {
                gigabytes = Math.round(gigabytes * 10) / 10;
                formatted = gigabytes + "GB";
            }
            else {
                formatted = "--";
            }

            return formatted;
        };
    });

})();